import { createSelectorHook, createDispatchHook, createStoreHook } from "react-redux";
import { buildCreateApi, coreModule, reactHooksModule } from "@reduxjs/toolkit/query/react";
import { StoreContext } from "../../context/store.js";
const createAppApi = buildCreateApi(
  coreModule(),
  reactHooksModule({
    hooks: {
      useStore: createStoreHook(StoreContext),
      useDispatch: createDispatchHook(StoreContext),
      useSelector: createSelectorHook(StoreContext)
    }
  })
);
export {
  createAppApi
};
